import img0 from "./img/large/p0.jpg";
import img17 from "./img/large/p17.jpg";
import img2 from "./img/large/p2.jpg";
import img3 from "./img/large/p3.jpg";
import img4 from "./img/large/p4.jpg";
import img5 from "./img/large/p5.JPG";
import img6 from "./img/large/p6.JPG";
import img7 from "./img/large/p7.jpg";
import img8 from "./img/large/p8.jpg";
import img9 from "./img/large/p9.jpg";
import img10 from "./img/large/p10.JPG";
import img11 from "./img/large/p11.JPG";
import img12 from "./img/large/p12.jpg";
import img13 from "./img/large/p13.jpg";
import img14 from "./img/large/p14.jpg";
import img15 from "./img/large/p15.JPG";
import img16 from "./img/large/p16.jpg";

import thum0 from "./img/thumb/p0.jpg";
import thum17 from "./img/thumb/p17.jpg";
import thum2 from "./img/thumb/p2.jpg";
import thum3 from "./img/thumb/p3.jpg";
import thum4 from "./img/thumb/p4.jpg";
import thum5 from "./img/thumb/p5.JPG";
import thum6 from "./img/thumb/p6.JPG";
import thum7 from "./img/thumb/p7.jpg";
import thum8 from "./img/thumb/p8.jpg";
import thum9 from "./img/thumb/p9.jpg";
import thum10 from "./img/thumb/p10.JPG";
import thum11 from "./img/thumb/p11.JPG";
import thum12 from "./img/thumb/p12.jpg";
import thum13 from "./img/thumb/p13.jpg";
import thum14 from "./img/thumb/p14.jpg";
import thum15 from "./img/thumb/p15.JPG";
import thum16 from "./img/thumb/p16.jpg";

export const images = [
  {
    id: 1,
    thumb: thum0,
    full: img0,
    alt: "Industrial 1",
  },

  {
    id: 3,
    thumb: thum2,
    full: img2,
    alt: "Industrial 3",
  },
  {
    id: 4,
    thumb: thum3,
    full: img3,
    alt: "Industrial 4",
  },
  {
    id: 5,
    thumb: thum4,
    full: img4,
    alt: "Industrial 5",
  },
  {
    id: 6,
    thumb: thum5,
    full: img5,
    alt: "Industrial 6",
  },
  {
    id: 7,
    thumb: thum6,
    full: img6,
    alt: "Industrial 7",
  },
  {
    id: 8,
    thumb: thum7,
    full: img7,
    alt: "Industrial 8",
  },
  {
    id: 9,
    thumb: thum8,
    full: img8,
    alt: "Industrial 9",
  },
  {
    id: 10,
    thumb: thum9,
    full: img9,
    alt: "Industrial10",
  },
  {
    id: 11,
    thumb: thum10,
    full: img10,
    alt: "Industrial11",
  },
  {
    id: 12,
    thumb: thum11,
    full: img11,
    alt: "Industrial12",
  },
  {
    id: 13,
    thumb: thum12,
    full: img12,
    alt: "Industrial13",
  },
  {
    id: 14,
    thumb: thum13,
    full: img13,
    alt: "Industrial14",
  },
  {
    id: 15,
    thumb: thum14,
    full: img14,
    alt: "Industrial15",
  },
  {
    id: 16,
    thumb: thum15,
    full: img15,
    alt: "Industrial16",
  },
  {
    id: 17,
    thumb: thum17,
    full: img17,
    alt: "Industrial17",
  },
];
